var _rect, _rect2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 2.18557e-08 -2.18557e-08)",
    fill: "#F4EAD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 2.18557e-08 -2.18557e-08)",
    stroke: "#FFF9EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 7 7)",
    fill: "#FF6F36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0922 28.5131C21.9114 28.0677 22.5193 27.4604 22.9157 26.6911C23.3122 25.9218 23.5104 25.013 23.5104 23.9603C23.5104 23.5824 23.4751 23.146 23.4091 22.6421C23.343 22.1427 23.202 21.6793 22.995 21.2429L29.8136 21C29.8665 21.3509 29.8973 21.6613 29.9105 21.9313C29.9237 22.2012 29.9326 22.4441 29.9326 22.6601C29.9326 24.1177 29.6815 25.3414 29.1793 26.3222C28.6772 27.3074 27.8755 28.0632 26.7831 28.5896C26.6069 28.6751 26.4219 28.7516 26.2281 28.828V29.071L42 29.071L42 30.92L26.2281 30.92V31.172C26.4219 31.2484 26.6113 31.3249 26.7831 31.4104C27.8799 31.9368 28.6772 32.6926 29.1793 33.6778C29.6815 34.6631 29.9326 35.8823 29.9326 37.3399C29.9326 37.5559 29.9237 37.7988 29.9105 38.0687C29.8973 38.3387 29.8621 38.6491 29.8136 39L22.995 38.7571C23.2065 38.3252 23.343 37.8573 23.4091 37.3579C23.4751 36.8585 23.5104 36.4176 23.5104 36.0397C23.5104 34.987 23.3122 34.0782 22.9157 33.3089C22.5193 32.5396 21.9114 31.9323 21.0922 31.4869C20.2729 31.0415 19.2421 30.7536 18 30.6186L18 29.3769C19.2421 29.2419 20.2729 28.9495 21.0922 28.5086V28.5131Z",
    fill: "#330C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon-return.766285d6166d946c77241d6f8ca02ef5.svg";
export { ForwardRef as ReactComponent };